import Cookies from 'js-cookie';
import axios from 'axios';

const AUTH_BASE_URL = (process.env.NODE_ENV !== 'development' ? 'https://api.patchboard.app' : 'http://localhost:8080') + '/v1';
const AUTH_COOKIE_NAME = 'auth';

const isLoggedIn = () => {
  return !!Cookies.get(AUTH_COOKIE_NAME);
};

const logout = () => {
  Cookies.remove(AUTH_COOKIE_NAME);
  Cookies.remove(AUTH_COOKIE_NAME, { domain: '.patchboard.app' });
};

const isAuthError = (error) => {
  return error && error.response && (error.response.status === 401 || error.response.status === 403);
};

const sendWithAuth = (method, path, data) => {
  return axios({
    url: AUTH_BASE_URL + path,
    method,
    data,
    withCredentials: true
  }).catch((error) => {
    if (isAuthError(error)) {
      logout();
    }
    throw error;
  });
};

const send = (method, path, data) => {
  return axios({
    url: AUTH_BASE_URL + path,
    method,
    data
  });
};

const loginWithEmailAndPassword = (email, password) => {
  return sendWithAuth('POST', '/user/session', { email, password });
};

const forgotPassword = (email) => {
  return send('POST', '/user/password/reset', { email });
};

const changePassword = (authorizer, newPassword, newPasswordConfirm) => {
  return sendWithAuth('POST', '/user/password', {
    ...authorizer,
    newPassword,
    newPasswordConfirm
  });
};

const createUser = (email, firstName, lastName) => {
  return sendWithAuth('POST', '/users', {
    email,
    firstName,
    lastName
  });
};

const fetchUserData = () => {
  return sendWithAuth('GET', '/user');
};

const fetchReleaseData = (name, version, platform, channel) => {
  platform = platform || 'mac';
  channel = channel || 'release';
  return send('GET', `/products/${name}/versions/${version}/releases/${platform}/channel/${channel}`);
};

const fetchPaymentHistory = () => {
  return sendWithAuth('GET', '/user/payment');
};

export {
  isLoggedIn,
  logout,
  loginWithEmailAndPassword,
  forgotPassword,
  changePassword,
  createUser,
  fetchUserData,
  fetchReleaseData,
  fetchPaymentHistory
};



// WEBPACK FOOTER //
// ./src/utils/auth.js